export default __webpack_public_path__ + "static/media/5. deliveries.d10bd876.png";